module.exports = __webpack_public_path__ + "static/icon-value.5e37bbf6.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-value.png
// module id = 294
// module chunks = 2